import React, { useState } from "react";
import "./Gallery.css";

/* Sliding Window Images */

const images = [
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765617920/ChatGPT_Image_Dec_13_2025_02_55_10_PM_mth8cu.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765617885/ChatGPT_Image_Dec_13_2025_02_53_52_PM_kbzyf7.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765908422/WhatsApp_Image_2025-12-16_at_9.52.34_AM_fbn3pl.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616808/WhatsApp_Image_2025-12-11_at_10.52.29_PM_myzebm.jpg",
   "https://res.cloudinary.com/di82vlbpn/image/upload/v1765908421/WhatsApp_Image_2025-12-16_at_10.06.41_AM_mdtfzb.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.33_PM_zq6hgf.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616718/WhatsApp_Image_2025-12-11_at_10.52.29_PM_1_n5qigb.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_totavb.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.29_PM_2_t5gvoq.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_1_fynu60.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.31_PM_twwzhf.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.37_PM_2_satxxp.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.33_PM_1_sc7zdz.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.36_PM_1_bhn37i.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.36_PM_znbixc.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.33_PM_2_izyvj3.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.37_PM_kqy8qb.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.37_PM_1_dapkee.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616715/WhatsApp_Image_2025-12-11_at_10.52.45_PM_d3twf2.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.38_PM_v8mbfl.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.39_PM_q8tztv.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616715/WhatsApp_Image_2025-12-11_at_10.52.53_PM_estai5.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.51_PM_1_dhfks2.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616715/WhatsApp_Image_2025-12-11_at_10.52.39_PM_2_ycocem.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616715/WhatsApp_Image_2025-12-11_at_10.52.53_PM_2_zecpsf.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616715/WhatsApp_Image_2025-12-11_at_10.52.47_PM_yoeoar.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.39_PM_1_mq8ksl.jpg",
   "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616715/WhatsApp_Image_2025-12-11_at_10.52.53_PM_1_wdtnih.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.51_PM_2_yyjlwo.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616715/WhatsApp_Image_2025-12-11_at_10.52.54_PM_2_kujbyt.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616714/WhatsApp_Image_2025-12-11_at_10.52.55_PM_2_okx0yh.jpg",
   "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616714/WhatsApp_Image_2025-12-11_at_10.52.55_PM_msp4xc.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616714/WhatsApp_Image_2025-12-11_at_10.52.47_PM_1_usc0ao.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616714/WhatsApp_Image_2025-12-11_at_10.52.54_PM_1_n00sga.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616714/WhatsApp_Image_2025-12-11_at_10.52.56_PM_wddlkm.jpg",
   "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616714/WhatsApp_Image_2025-12-11_at_10.52.48_PM_tqixm6.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616714/WhatsApp_Image_2025-12-11_at_10.52.50_PM_1_vd3ghg.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616714/WhatsApp_Image_2025-12-11_at_10.52.50_PM_x5cp4n.jpg",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1765616713/WhatsApp_Image_2025-12-11_at_10.52.55_PM_3_av6bwn.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1765619244/WhatsApp_Image_2025-12-11_at_10.52.44_PM_car5n4.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1765619244/WhatsApp_Image_2025-12-11_at_10.52.46_PM_p90xcl.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_2_ngm3im.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1765616716/WhatsApp_Image_2025-12-11_at_10.52.51_PM_vzx10a.jpg"

];



/* Still Railing */
const Still = [
  
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562733/WhatsApp_Image_2026-03-15_at_1.02.10_AM_peiezj.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562733/WhatsApp_Image_2026-03-15_at_1.02.11_AM_mrfzfz.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562726/WhatsApp_Image_2026-03-15_at_1.02.11_AM_1_wzi8g4.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562726/WhatsApp_Image_2026-03-15_at_1.02.11_AM_2_t8xw9h.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562725/WhatsApp_Image_2026-03-15_at_1.02.12_AM_co9gkx.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562724/WhatsApp_Image_2026-03-15_at_1.02.14_AM_b4z7pp.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562722/WhatsApp_Image_2026-03-15_at_1.02.15_AM_yyphup.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562719/WhatsApp_Image_2026-03-15_at_1.02.16_AM_i4nsnr.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562705/WhatsApp_Image_2026-03-15_at_1.02.21_AM_1_ssmw9p.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562719/WhatsApp_Image_2026-03-15_at_1.02.15_AM_1_tpbjuw.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562718/WhatsApp_Image_2026-03-15_at_1.02.15_AM_2_zq60ov.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562717/WhatsApp_Image_2026-03-15_at_1.02.16_AM_1_q0agmj.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562718/WhatsApp_Image_2026-03-15_at_1.02.17_AM_w9pqxp.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562706/WhatsApp_Image_2026-03-15_at_1.02.18_AM_x6ilqw.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562706/WhatsApp_Image_2026-03-15_at_1.02.22_AM_1_di7q2x.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562706/WhatsApp_Image_2026-03-15_at_1.02.18_AM_1_wrukpq.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562706/WhatsApp_Image_2026-03-15_at_1.02.22_AM_suswq1.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562706/WhatsApp_Image_2026-03-15_at_1.02.21_AM_tzgdhy.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562706/WhatsApp_Image_2026-03-15_at_1.02.20_AM_t0x7sv.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562706/WhatsApp_Image_2026-03-15_at_1.02.19_AM_jozejk.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562706/WhatsApp_Image_2026-03-15_at_1.02.19_AM_1_bowul0.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562705/WhatsApp_Image_2026-03-15_at_1.02.20_AM_1_cnq94y.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562705/WhatsApp_Image_2026-03-15_at_1.02.23_AM_1_j0rhd1.jpg",
"https://res.cloudinary.com/di82vlbpn/image/upload/v1773562705/WhatsApp_Image_2026-03-15_at_1.02.23_AM_pszqq5.jpg",


];


/* PVC False Ceiling */
const PVCfalseCeiling = [


"https://images.jdmagicbox.com/quickquotes/images_main/pvc-false-ceiling-grey-5-10-mm-2226536985-sf015fo3.jpg",
"https://jayswal.in/web/wp-content/uploads/2021/01/cropped-Pvc-Planks-false-ceilings-jitex-suppliers-bangalore-3.jpg",
"https://img.staticmb.com/mbimages/interiorDesignerCMS/decorPartner/103/projectImage/latest%20pvc%20false%20ceiling%20design%20for%20bedroom%204.jpg.webp",
,"https://images.jdmagicbox.com/quickquotes/images_main/pvc-false-ceiling-grey-5-10-mm-2226536985-sf015fo3.jpg",

"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCeCblLXHRwUs9w3jZUo0RKM3Sz0Hr3LPUMA&s",
// ,""
// ,""
// ,""
// ,""
// ,""
// ,""
// ,""
// ,""
// ,""
// ,""
// ,""

];

/* Modular Kitchen */
const ModularKitchen = [

"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkoV_Ts5qOGd1n92FhBKTX9Cm6j08bNLl6rA&s",
"https://webtk.sfastservices.com/blogimg/Modular%20Kitchen%20Prices%20Sfastservices.jpg",
"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQoCE9AhkiA-jtHeFtuy17rX_9rG47DPfxxrpMa0SU6Zg&s",
"https://api.gharpedia.com/wp-content/uploads/2018/12/Modular-Kitchen-01-0503070018.jpg",


// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",
// "",

];

/* YouTube Videos */
const videos = [
"https://www.youtube.com/watch?v=9BZU8lpJwGs&t=4s",
"https://www.youtube.com/watch?v=bmLt7XBIq78",
"https://www.youtube.com/watch?v=kiQCEsKwas4"
];

const Gallery = () => {

const [activeTab, setActiveTab] = useState("images");

return (

<div className="gallery-page">

<h2 className="gallery-title">Our Gallery</h2>

{/* Tabs */}
<div className="gallery-tabs">

<div
className={`tab-btn ${activeTab === "images" ? "active" : ""}`}
onClick={() => setActiveTab("images")}
>
Images
</div>

<div
className={`tab-btn ${activeTab === "Still" ? "active" : ""}`}
onClick={() => setActiveTab("Still")}
>
Still Railing
</div>

<div
className={`tab-btn ${activeTab === "PVCfalseCeiling" ? "active" : ""}`}
onClick={() => setActiveTab("PVCfalseCeiling")}
>
PVC False Ceiling
</div>

<div
className={`tab-btn ${activeTab === "ModularKitchen" ? "active" : ""}`}
onClick={() => setActiveTab("ModularKitchen")}
>
Aluminium Modular Kitchen
</div>

<div
className={`tab-btn ${activeTab === "videos" ? "active" : ""}`}
onClick={() => setActiveTab("videos")}
>
Videos
</div>

</div>

{/* Sliding Window */}
{activeTab === "images" && (
<div className="masonry-grid">
{images.map((img, index) => (
<div className="masonry-item" key={index}>
<img src={img} alt={`gallery-${index}`} loading="lazy" />
</div>
))}
</div>
)}

{/* Still Railing */}
{activeTab === "Still" && (
<div className="masonry-grid">
{Still.map((img, index) => (
<div className="masonry-item" key={index}>
<img src={img} alt={`gallery-${index}`} loading="lazy" />
</div>
))}
</div>
)}

{/* PVC False Ceiling */}
{activeTab === "PVCfalseCeiling" && (
<div className="masonry-grid">
{PVCfalseCeiling.map((img, index) => (
<div className="masonry-item" key={index}>
<img src={img} alt={`gallery-${index}`} loading="lazy" />
</div>
))}
</div>
)}

{/* Modular Kitchen */}
{activeTab === "ModularKitchen" && (
<div className="masonry-grid">
{ModularKitchen.map((img, index) => (
<div className="masonry-item" key={index}>
<img src={img} alt={`gallery-${index}`} loading="lazy" />
</div>
))}
</div>
)}

{/* Videos */}
{activeTab === "videos" && (
<div className="video-grid">

{videos.map((video, index) => {

let videoId = "";

if (video.includes("shorts")) {
videoId = video.split("shorts/")[1];
} else {
videoId = video.split("v=")[1]?.split("&")[0];
}

return (
<div className="video-card" key={index}>
<div className="video-wrapper">
<iframe
src={`https://www.youtube.com/embed/${videoId}`}
title={`video-${index}`}
frameBorder="0"
allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
allowFullScreen
></iframe>
</div>
</div>
);

})}

</div>
)}

</div>
);

};

export default Gallery;